import { Icon } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import createArticleDraftData from "astrid-firestore/src/api/articles/createArticleDraftData";

import Button from "../../../ui/components/Buttons/Button";
import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";
import PlaceholderSegment from "../../../ui/components/PlaceholderSegment/PlaceholderSegment";

import Form from "../../../forms/components/Form/Form";
import useSimpleForm from "../../../forms/hooks/useSimpleForm";

import useArticles from "../../hooks/useArticles";

import ArticleEdit from "../ArticleEdit/ArticleEdit";
import ArticleSegment from "../ArticleSegment/ArticleSegment";

export default function AddArticleModal({
	work,
	publisher,
	production,
	channels,
	articleIds: defaultArticleIds,
	disableAdd,
	onSubmit: submitHandler,
	onClose,
}) {
	const { t } = useTranslation();

	const [articles, loading] = useArticles({ work });

	const [articleDraft, setArticleDraft] = useState(null);

	const { form, watch, onSubmit, getValues, setValue, error } = useSimpleForm({
		defaultValues: {
			articleIds: defaultArticleIds || production.articleIds || [],
		},
		onSubmit: submitHandler,
		onSuccess: onClose,
	});

	const toggleArticle = (id) => {
		const articleIds = getValues("articleIds");

		setValue("articleIds", articleIds.includes(id) ? articleIds.filter((aId) => aId !== id) : [...articleIds, id]);
	};

	const articleIds = watch("articleIds");

	if (articleDraft) {
		return (
			<ArticleEdit
				overlay
				work={work}
				article={articleDraft}
				channels={channels}
				publisher={publisher}
				production={production}
				onSuccess={({ id }) => toggleArticle(id)}
				onClose={() => setArticleDraft(null)}
			/>
		);
	}

	return (
		<Form.Modal
			header={t("addArticle", "Add article")}
			size="tiny"
			form={form}
			error={error}
			onSubmit={onSubmit}
			onClose={onClose}
			scrolling
		>
			<LoadingContext loading={loading}>
				{articles?.map((article) => {
					const selected = articleIds.includes(article.id);

					return (
						<ArticleSegment
							key={article.id}
							article={article}
							onClick={() => toggleArticle(article.id)}
							extra={
								<Icon
									size="large"
									name={selected ? "check circle" : "circle"}
									color={selected ? "blue" : "grey"}
								/>
							}
						/>
					);
				})}

				{!disableAdd && (
					<PlaceholderSegment
						onClick={() => setArticleDraft(createArticleDraftData({ work, publisher, production }))}
					>
						<Button>{t("createArticle", "Create Article")}</Button>
					</PlaceholderSegment>
				)}
			</LoadingContext>
		</Form.Modal>
	);
}
